// Start load members data and get ids
// Check login at 1000 interval or something...
// display form with button to open
// handle and communicate error states
// no members found...
// no data found...
// 500 internal server error
// not logged in...
import { getMembers } from "../threads/directory/getMembers";
import { scrapeDirectoryHTML } from "../threads/directory/scrape/scrapeDirectoryHTML";
import { checkLogin } from "./checkLogin";
import { renderDownloadUI } from "./renderDownloadUI";
import "./index.scss";
init();
function init() {
    const html = document.querySelector(".attendance-data");
    let members;
    html.innerHTML = `
        <p class="attendance-data__loading">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i>
            Loading members, hang tight!
        </p>
    `;
    Promise.all([
        scrapeDirectoryHTML({ needMemberId: true }).then(({ families }) => {
            members = getMembers(families);
        }),
        checkLogin(html),
    ]).then(() => renderDownloadUI(html, members));
}
